const INSTANCE_PLURAL: Record<string, string> = {
	Job: "jobs",
	Ticket: "tickets",
	Asset: "assets",
	Record: "records",
};

const TYPE_ROUTE: Record<string, string> = {
	JobType: "jobTypes",
	TicketType: "ticketTypes",
	AssetType: "assetTypes",
	RecordType: "recordTypes",
};

export function resolveLiveUpdateCloseHref(
	pathname: string,
	entityType: string,
	entityId: string,
): string | null {
	const segments = pathname.split("/").filter(Boolean);
	const normalizedId = entityId.toLowerCase();

	if (entityType === "StatusLifecycle") {
		const lifecycleIndex = segments.findIndex(
			(segment, index) =>
				segment === "lifecycles" &&
				segments[index + 1]?.toLowerCase() === normalizedId,
		);
		if (lifecycleIndex >= 0) {
			return `/${segments.slice(0, lifecycleIndex + 1).join("/")}`;
		}
		return null;
	}

	const typeRoute = TYPE_ROUTE[entityType];
	if (typeRoute) {
		const typeIndex = segments.findIndex(
			(segment, index) =>
				segment === typeRoute &&
				segments[index + 1]?.toLowerCase() === normalizedId,
		);
		if (typeIndex >= 0) {
			return `/${segments.slice(0, typeIndex + 1).join("/")}`;
		}
		return null;
	}

	const plural = INSTANCE_PLURAL[entityType];
	if (!plural) return null;

	const entityIndex = segments.findIndex(
		(segment, index) =>
			segment === plural &&
			segments[index + 1]?.toLowerCase() === normalizedId,
	);
	if (entityIndex < 0) return null;

	return `/${segments.slice(0, entityIndex + 1).join("/")}`;
}
